/**
 * Default values for pagination
 */
export const DEFAULT_PAGINATION = {
    pageNumber: '0',
    get rowsPerPage() {
        return localStorage.getItem('rowsPerPage') || '10'
    },
    set rowsPerPage(value: string) {
        localStorage.setItem('rowsPerPage', value)
    },
}
